<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Users Visited'}} {{(fillableData.length>0)? fillableData[0].co_name: ''}}</strong>
        </div>
        <div class="col-md-1">
          <download :tableId="'user-activity'" :fileName="'users-list'"></download>
        </div>
        <div class="col-md-1">
          <router-link exact class="btn btn-sm" :to="'/reports/trending-company'">
                <i class="fa fa-caret-left"></i> Go Back
              </router-link>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="table-responsive app" v-dragscroll="true">
        <table id="user-activity" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
              <td>
                <span>{{(index+1)+(perPage*($refs.page.current_page-1))}}</span>
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='date'">{{getDateTime(row[field.name])}}</span>
                <span
                  v-else-if="field.name==='name'"
                >{{(row['first_name'])? row['first_name'] + ' ' + row['last_name']: 'Guest'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+actions.length+1)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <pagination
          ref="page"
          :pageName="pageType"
          :totPages="totalPages"
          :apiUrl="apiUrl"
          @changePage="pageChange"
        ></pagination>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  name: "UserActivityReport",
  created() {
    if (!this.$route.params.id) {
      // this.$router.push({ name: "trending-company-report" });
    }
    this.co_code = this.$route.params.id;
    console.log(this.$route.params, this.co_code);
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    }
  },
  data() {
    return {
      apiUrl: "userActivityReport",
      pageType: "user-activity-report",
      perPage: 100,
      co_code: "",
      company: {},
      actions: [
        // {
        //   btnClass: "btn-info",
        //   icon: "fa-list cwhite",
        //   callback: this.viewRawData,
        //   tooltip: "Raw Data"
        // },
      ],
      tableFields: [
        {
          name: "name",
          title: "User Name"
        },
        {
          name: "co_name",
          title: "Company"
        },
        {
          name: "date",
          title: "Date Time"
        }
      ],
      paginationPath: "",
      searchParams: {},
      fillableData: [],
      url: "",
      page: 1,
      totalPages: 1
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if (this.searchParams.sectorname != "") {
          localStorage.setItem("secC", this.searchParams.sectorname);
        }
        this.fetchData(this.searchParams);
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-activity-report" });
      this.searchParams = {};
      this.current_page = 1;
      this.url = this.apiUrl;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = { pageid: myself.page, co_code: this.co_code };
        http.post(this.apiUrl, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") {
          myself.fillableData = response.final_data;
          myself.totalPages = response.total_pages;
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    pageChange(url) {
      console.log("changeUrl", url);
      this.url = url;
      this.page = url.page;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/reports/trending-company-users.vue